import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {AbstractSheetController} from '@mintdata-wsp/common/controllers/spreadsheet/AbstractSheetController';
import {MeshRange} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/MeshRange';
import {NestedFrameSlot} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/nestedFrameSlot/NestedFrameSlot';
import {NestedSheet} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/NestedSheet';
import {SlotStatus} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/slot/SlotStatus';
import {SlotFormula} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/slot/SlotTypes';
import {SlotLocation} from '@mintdata-wsp/common/state/ui/visualDesigner/spreadsheet/SlotLocation';
import {SheetId, SlotId} from '@mintdata/mint-kit/api/models/Identifiers';
import {Type} from '@mintdata/mint-kit/api/types/Type';
import {IValue} from '@mintdata/mint-kit/api/types/Value';
import {IFrame} from '@mintdata/mint-kit/api/values/frames/Frame';
import bind from 'bind-decorator';
import {action} from 'mobx';

export class NestedFrameController extends AbstractSheetController
{

    @bind
    public getOrCreateSlot(sheetId:SheetId, slotLocation:SlotLocation):NestedFrameSlot
    {
        return this.findSlot(sheetId, slotLocation);
    }

    @bind
    public findSlotById(sheetId:SheetId, slotId:SlotId):NestedFrameSlot | null
    {
        return null;
    }

    @bind
    public findSlot(sheetId:SheetId, slotLocation:SlotLocation):NestedFrameSlot | null
    {
        const sheet:NestedSheet = commonControllers.spreadsheets.main.findAnySheetById(sheetId, true) as NestedSheet;
        return (sheet && sheet.getSlotByLocation(slotLocation)) || null;
    }

    @bind
    public getNumOfCells(sheetId:SheetId):number
    {
        const sheet:NestedSheet = commonControllers.spreadsheets.main.findAnySheetById(sheetId, true) as NestedSheet;
        return (sheet && sheet.getNumOfCells()) || 0;
    }

    @bind
    public getSlotStatus(sheetId:SheetId, slotLocation:SlotLocation):SlotStatus | null
    {
        return null;
    }

    @bind
    public isAnySlotLoading(sheetId:SheetId):boolean
    {
        return false;
    }

    @action.bound
    public terminateSlot(slot:NestedFrameSlot):void
    {
    }

    @action.bound
    public setSlotFormulas(sheetId:SheetId,
                           slotLocations:Array<SlotLocation>,
                           formulas:Array<SlotFormula>,
                           formats:Array<string>):void
    {
    }

    @action.bound
    public setSlotFormula(sheetId:SheetId,
                          slotLocation:SlotLocation,
                          formula:SlotFormula,
                          guessFormat:boolean = true):void
    {
    }

    @action.bound
    public makeSlotLazy(sheetId:SheetId,
                        slotLocation:SlotLocation):void
    {
    }

    @action.bound
    public makeSlotRegular(sheetId:SheetId,
                           slotLocation:SlotLocation):void
    {
    }

    @action.bound
    public clearSlot(sheetId:SheetId, slotLocation:SlotLocation):void
    {
    }

    @action.bound
    public clearSlots(sheetId:SheetId, meshRange:MeshRange):void
    {
    }

    @action.bound
    public async reEvaluateSlot(sheetId:SheetId, slotLocation:SlotLocation):Promise<boolean>
    {
        return true;
    }

    @action.bound
    public async forceEvaluateSlot(sheetId:SheetId, slotLocation:SlotLocation):Promise<boolean>
    {
        return true;
    }

    @action.bound
    public async reEvaluateLazySlot(sheetId:SheetId, slotLocation:SlotLocation, eventFrame?:IFrame):Promise<boolean>
    {
        return true;
    }

    @action.bound
    public abortSlotEvaluation(sheetId:SheetId, slotLocation:SlotLocation):void
    {
    }

    @action.bound
    public insertColumns(sheetId:SheetId, fromColumnIndex:number, columnsCount:number):void
    {
    }

    @action.bound
    public insertRows(sheetId:SheetId, fromRowIndex:number, rowsCount:number):void
    {
    }

    @action.bound
    public insertCellsRight(sheetId:SheetId, fromColumnIndex:number, columnsCount:number):void
    {
    }

    @action.bound
    public insertCellsDown(sheetId:SheetId, fromColumnIndex:number, columnsCount:number):void
    {
    }

    @action.bound
    public deleteColumns(sheetId:SheetId, fromColumnIndex:number, columnsCount:number, keepBindings:boolean):void
    {
    }

    @action.bound
    public deleteRows(sheetId:SheetId, fromRowIndex:number, rowsCount:number, keepBindings:boolean):void
    {
    }

    @bind
    public getSlotFrameValue(sheetId:SheetId, slotLocation:SlotLocation):IFrame
    {
        return this.getSlotValue(sheetId, slotLocation) as IFrame;
    }

    @bind
    public isSlotFrameValue(sheetId:SheetId, slotLocation:SlotLocation):boolean
    {
        const slotValue:IValue = this.getSlotValue(sheetId, slotLocation);

        return Type.isInstanceOf(slotValue, Type.Frame);
    }

    @action.bound
    public setSlotValue(sheetId:SheetId, slotLocation:SlotLocation, value:IValue):void
    {
    }
}
